import React from 'react';
import Header from "../../components/Header"
//import Nav from "../../components/Nav" || No Longer Used

import * as Styled from './styles.js';

function HomePage() {
    return (
        <Styled.HomePage>
            <Header /> 

        </Styled.HomePage>
    )
}

export default HomePage;